var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component announcementContainer"},[_c('paginator',{attrs:{"pages":_vm.maxPages},on:{"changepage":_vm.changePage}}),_c('div',_vm._l((_vm.announcements),function(announcement){return _c('announcement',{key:announcement.id,attrs:{"announcement":announcement}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }